<script>
	// 미리보기 패널 "응답" 탭: 지금 편집 중인(포커스한) 폼 블록의 응답만 카드로 보여준다.
	// 블록을 클릭(포커스)하면 BlockContext가 chat.responsesBlockId를 지정 → 이 패널이 그 블록으로 조회.
	import { PRConnect } from "@projectroom/ui-lib";
	import ResponseCard from "./ResponseCard.svelte";

	export let chat;
	export let blockId;
	export let label = "";

	const CAP = 200;
	let rows = [];
	let total = 0;
	let loading = false;
	let loadedFor = null;

	const load = () => {
		if (!chat?.chatId || !blockId) {
			rows = [];
			total = 0;
			return;
		}
		loading = true;
		PRConnect.send(
			"/api/Chat/getFormSubmissions",
			{ chatId: chat.chatId, blockId, page: 1, pageSize: CAP },
			(data) => {
				loading = false;
				if (data.header.status !== "success") return;
				const r = data.result || {};
				rows = r.list || [];
				total = r.total || 0;
			},
		);
	};
	// 대상 블록이 바뀌면 재조회(같은 블록이면 중복 호출 안 함).
	$: if (blockId && blockId !== loadedFor) {
		loadedFor = blockId;
		load();
	}
</script>

<div class="brp">
	<div class="brp-h">
		<div class="brp-t" title={label}>{label || blockId}</div>
		<span class="brp-c">{total}건</span>
		<button type="button" class="brp-refresh" on:click={load} disabled={loading} title="새로고침">↻</button>
	</div>
	{#if loading && rows.length === 0}
		<div class="brp-empty">불러오는 중…</div>
	{:else if rows.length === 0}
		<div class="brp-empty">아직 이 폼에 제출된 응답이 없어요.<br />폼을 제출하면 여기에 쌓여요.</div>
	{:else}
		<div class="brp-list">
			{#each rows as row (row.id)}
				<ResponseCard {row} />
			{/each}
		</div>
		{#if total > rows.length}
			<div class="brp-more">최근 {rows.length}건 표시 · 전체 {total}건</div>
		{/if}
	{/if}
</div>

<style>
	.brp {
		display: flex;
		flex-direction: column;
		gap: 8px;
		width: 100%;
		font-family:
			-apple-system, BlinkMacSystemFont, "Segoe UI", "Apple SD Gothic Neo", "Malgun Gothic", sans-serif;
	}
	.brp-h {
		display: flex;
		align-items: center;
		gap: 8px;
		padding-bottom: 2px;
	}
	.brp-t {
		font-size: 13px;
		font-weight: 600;
		color: hsl(var(--sb-foreground));
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.brp-c {
		font-size: 11px;
		color: hsl(var(--sb-muted-foreground));
		white-space: nowrap;
	}
	.brp-refresh {
		margin-left: auto;
		width: 24px;
		height: 24px;
		border: 1px solid hsl(var(--sb-border));
		border-radius: 6px;
		background: hsl(var(--sb-muted));
		color: hsl(var(--sb-muted-foreground));
		cursor: pointer;
		font-size: 13px;
		line-height: 1;
	}
	.brp-refresh:disabled {
		opacity: 0.5;
		cursor: default;
	}
	.brp-empty {
		padding: 24px 12px;
		text-align: center;
		font-size: 12.5px;
		line-height: 1.7;
		color: hsl(var(--sb-muted-foreground));
		border: 1px dashed hsl(var(--sb-border));
		border-radius: 8px;
	}
	.brp-list {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
	.brp-more {
		text-align: center;
		font-size: 11px;
		color: hsl(var(--sb-muted-foreground));
		padding-top: 2px;
	}
</style>
